import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	ordersBtc: {
		data: [],
		error: null,
		loading: false,
		totalCount: 0,
		tableParams: {
			page: 0,
			size: 10,
		},
	},
	accountants: { error: null, loading: null, data: null },
	orderBtc: { error: null, loading: false, data: null },
	createManyOrderBtc: { error: null, loading: false, data: null },
	editedOrderBtc: { error: null, loading: false, data: null },
	packageSizes: { error: null, loading: false, data: null },
	statuses: { error: null, loading: false, data: null },
	downloadXlsx: { error: null, loading: false },
};

const { actions, reducer } = createSlice({
	name: 'ordersBtc',
	initialState,
	reducers: {
		getOrdersBtc: (state, { payload }) => {
			const { saveConfig = true, ...restPayload } = payload;
			state.ordersBtc = {
				...state.ordersBtc,
				...(saveConfig ? { tableParams: restPayload } : {}),
				error: null,
				loading: true,
			};
		},
		getOrdersBtcFailure: (state, { payload }) => {
			state.ordersBtc = {
				...state.ordersBtc,
				error: payload,
				loading: false,
			};
		},
		getOrdersBtcSuccess: (state, { payload }) => {
			state.ordersBtc = {
				...state.ordersBtc,
				data: payload.body,
				totalCount: payload.meta.totalCount,
				error: null,
				loading: false,
			};
		},
		getOrderBtcById: (state, { payload }) => {
			state.orderBtc = {
				...state.orderBtc,
				error: null,
				loading: true,
			};
		},
		getOrderBtcByIdFailure: (state, { payload }) => {
			state.orderBtc = {
				...state.orderBtc,
				error: payload,
				loading: false,
			};
		},
		getOrderBtcByIdSuccess: (state, { payload }) => {
			state.orderBtc = {
				...state.orderBtc,
				data: payload,
				error: null,
				loading: false,
			};
		},
		getAccountantsBtcByClientId: (state, { payload }) => {
			state.accountants = {
				...state.accountants,
				error: null,
				loading: true,
			};
		},
		getAccountantsBtcByClientIdFailure: (state, { payload }) => {
			state.accountants = {
				...state.accountants,
				error: payload,
				loading: false,
			};
		},
		getAccountantsBtcByClientIdSuccess: (state, { payload }) => {
			state.accountants = {
				...state.accountants,
				data: payload,
				error: null,
				loading: false,
			};
		},
		createManyOrderBtc: (state, { payload }) => {
			state.createManyOrderBtc = {
				...state.createManyOrderBtc,
				error: null,
				loading: true,
			};
		},
		createManyOrderBtcFailure: (state, { payload }) => {
			state.createManyOrderBtc = {
				...state.createManyOrderBtc,
				error: payload,
				loading: false,
			};
		},
		createManyOrderBtcSuccess: (state, { payload }) => {
			state.createManyOrderBtc = {
				...state.createManyOrderBtc,
				data: payload,
				error: null,
				loading: false,
			};
		},
		scanFinalizeOrderBtc: (state, { payload }) => {
			state.editedOrderBtc = {
				...state.editedOrderBtc,
				data: null,
				error: null,
				loading: true,
			};
		},
		scanFinalizeOrderBtcFailure: (state, { payload }) => {
			state.editedOrderBtc = {
				...state.editedOrderBtc,
				error: payload,
				loading: false,
			};
		},
		scanFinalizeOrderBtcSuccess: (state, { payload }) => {
			state.editedOrderBtc = {
				...state.editedOrderBtc,
				data: payload,
				error: null,
				loading: false,
			};
		},
		finalizeOrderBtc: (state) => {
			state.editedOrderBtc = {
				...state.editedOrderBtc,
				data: null,
				error: null,
				loading: true,
			};
		},
		finalizeOrderBtcFailure: (state, { payload }) => {
			state.editedOrderBtc = {
				...state.editedOrderBtc,
				error: payload,
				loading: false,
			};
		},
		finalizeOrderBtcSuccess: (state, { payload }) => {
			state.editedOrderBtc = {
				...state.editedOrderBtc,
				data: payload,
				error: null,
				loading: false,
			};
		},
		unfullfillOrderBtc: (state, { payload }) => {
			state.editedOrderBtc = {
				...state.editedOrderBtc,
				error: null,
				loading: true,
			};
		},
		unfullfillOrderBtcFailure: (state, { payload }) => {
			state.editedOrderBtc = {
				...state.editedOrderBtc,
				error: payload,
				loading: false,
			};
		},
		unfullfillOrderBtcSuccess: (state, { payload }) => {
			state.editedOrderBtc = {
				...state.editedOrderBtc,
				data: payload,
				error: null,
				loading: false,
			};
		},
		getPackageSizes: (state, { payload }) => {
			state.packageSizes = {
				...state.packageSizes,
				error: null,
				loading: true,
			};
		},
		getPackageSizesFailure: (state, { payload }) => {
			state.packageSizes = {
				...state.packageSizes,
				error: payload,
				loading: false,
			};
		},
		getPackageSizesSuccess: (state, { payload }) => {
			state.packageSizes = {
				...state.packageSizes,
				data: payload,
				error: null,
				loading: false,
			};
		},
		getOrderStatuses: (state, { payload }) => {
			state.statuses = {
				...state.statuses,
				error: null,
				loading: true,
			};
		},
		getOrderStatusesFailure: (state, { payload }) => {
			state.statuses = {
				...state.statuses,
				error: payload,
				loading: false,
			};
		},
		getOrderStatusesSuccess: (state, { payload }) => {
			state.statuses = {
				...state.statuses,
				data: payload,
				error: null,
				loading: false,
			};
		},
		downloadXlsx: (state, { payload }) => {
			state.downloadXlsx = {
				...state.downloadXlsx,
				error: null,
				loading: true,
			};
		},
		downloadXlsxFailure: (state, { payload }) => {
			state.downloadXlsx = {
				...state.downloadXlsx,
				error: payload,
				loading: false,
			};
		},
		downloadXlsxSuccess: (state, { payload }) => {
			state.downloadXlsx = {
				...state.downloadXlsx,
				error: null,
				loading: false,
			};
		},
	},
});

export const {
	getOrdersBtc,
	getOrdersBtcFailure,
	getOrdersBtcSuccess,
	getOrderBtcById,
	getOrderBtcByIdFailure,
	getOrderBtcByIdSuccess,
	scanFinalizeOrderBtc,
	scanFinalizeOrderBtcFailure,
	scanFinalizeOrderBtcSuccess,
	finalizeOrderBtc,
	finalizeOrderBtcFailure,
	finalizeOrderBtcSuccess,
	unfullfillOrderBtc,
	unfullfillOrderBtcFailure,
	unfullfillOrderBtcSuccess,
	getPackageSizes,
	getPackageSizesFailure,
	getPackageSizesSuccess,
	getOrderStatuses,
	getOrderStatusesFailure,
	getOrderStatusesSuccess,
	downloadXlsx,
	downloadXlsxFailure,
	downloadXlsxSuccess,
	createManyOrderBtc,
	createManyOrderBtcFailure,
	createManyOrderBtcSuccess,
	getAccountantsBtcByClientId,
	getAccountantsBtcByClientIdFailure,
	getAccountantsBtcByClientIdSuccess,
} = actions;

export { default as ordersBtcSaga } from './sagas';

export default reducer;
